import {Link} from 'react-router-dom';
import React from "react";
import {PageModel} from "../../features/page/pageTypes";


type Props = {
    page: PageModel;
    onClick: () => void;
}


const HeaderPageItem = ({page, onClick}: Props) => {
    return (
        <li className={`nav-item text-center`}>
            <Link onClick={onClick} to={`/page/${page.slug}`} className={`nav-link text-decoration-none `}>
                {page.name}
            </Link>
        </li>
    )
}

export default HeaderPageItem;
